<template>
  <div :class="['under-camera', rounded ? 'rounded':'']">
    <div>
      <v-card-title>
        Forecast
      </v-card-title>
      <v-card-subtitle>
        Visitors in 30 min
      </v-card-subtitle>
    </div>
    <div class="forecast-number">
                <span v-if="loading">
                <v-progress-circular v-if="loading" size="20" width="2"
                                     indeterminate
                                     color="white"
                ></v-progress-circular>
              </span>
      <span v-else>
                  <!-- {{forecast}} -->
                  {{1}}
                </span></div>
    <img class="background-logo" src="/static/dashboard_card.png" alt="logo">
  </div>
</template>

<script>
  export default {
    name: "ScanVisitorsInfo",
    props: ['loading', 'forecast','rounded'],
  }
</script>

<style lang="scss" scoped>
  .under-camera {
    position: relative;
    color: white !important;
    background: var(--v-primary-base);
    display: grid;
    grid-template-columns: 1fr auto;
    overflow: hidden;
    border-radius: 0 0 8px 8px;

    .forecast-number {
      align-self: center;
      font-size: 42px;
      font-weight: 500;
      margin: 0 16px;

    }

    img {
      position: absolute;
      left: 0;
      top: -70px;
      overflow: hidden;
    }
    &.rounded {
      border-radius: 8px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/Elements/ScanVisitorsInfo.vue